import axios from 'axios'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Delete } from '@mui/icons-material';
import { Alert, Button, Dialog, DialogContent, FormControlLabel, FormGroup, IconButton, Snackbar, Switch } from '@mui/material';
import { useLocation } from 'react-router';
import { useFormik } from 'formik';
import { quizlinkSchema } from '../schemas';

const Recruitment = ()=>{
    const [members, setMembers] = useState([])
    const [membersCount, setMembersCount] = useState()
    const [resultCount, setResultCount] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [results, setResult] = useState([])
    const uri = useSelector(state=>state.uri)    
    const [error, setError] = useState('')
    const [snackbarstatus, setSnackbarStatus] = useState(false)
    const [delDialog, setDelDialog] = useState(false)
    const [response, setResponse] = useState('')
    const location = useLocation()

    useEffect(()=>{
        axios.get(
            `${uri}records`,            
        ).then(res=>{       
            console.log(res.data)     
            setIsLoading(false)            
            setMembers(res.data.members)
            setMembersCount(res.data.membersCount)
            setResultCount(res.data.results)
            setResult(res.data.allResult)
        }).catch(err=>{
            console.log(err.response)            
            setIsLoading(false)
        })
    }, [response])
    const handleClose = (event, reason)=>{
        if (reason == 'clickaway') {
            return;
        }

        setSnackbarStatus(false)

    }
    const acceptingResponse = (event)=>{
        setDelDialog(true)
        axios.put(
            `${uri}services`,
            {active: event.target.checked}
        ).then(res=>{  
            // fetchService()         
            setDelDialog(false)
            setSnackbarStatus(true)
            setResponse(res.data.message)
        }).catch((err)=>{
            setDelDialog(false)
            setSnackbarStatus(true)
            setResponse('An error occured!')
        })        
    }
    const {handleChange, handleBlur, handleSubmit, handleReset, errors, touched} = useFormik({
        initialValues: {            
            quiz: ''            
        },
        validationSchema: quizlinkSchema,
        onSubmit: (values)=>{
            setDelDialog(true)
            axios.post(
                `${uri}quiz`,
                values
            ).then(res=>{
                setDelDialog(false)
                setSnackbarStatus(true)
                setResponse(res.data.message)
                handleReset()
            }).catch(err=>{
                setDelDialog(false)
                setSnackbarStatus(true)
                setResponse('An error occured!')
            })
        }
    })
    return (
        <Fragment>
            <div className='container text-dark mt-lg-0 mt-5 font-poppins'>
                <p className='fw-bold-0 fs-4 pt-lg-0 pt-2'>
                    Recruitment for New Members
                </p>
                <p className='fs-6'>
                    Send Quiz Link, Peruse new members and their assessment results.
                </p>
                <div className='d-flex mb-2 flex-md-row flex-column'>
                    <Button className='bg-yrh text-white'>
                        Start Recruitment
                    </Button>
                    <div className='mx-md-4'>
                        <FormGroup className='font-poppins'>
                            <FormControlLabel className='font-poppins' control={<Switch onChange={(e)=>acceptingResponse(e)} checked={true} />} label='Accepting responses' />
                        </FormGroup>                                            
                    </div>
                </div>
                <div className='col-md-6 d-flex justify-content-between'>
                    <p>
                        <span className='text-yrh fs-4 fw-bold'>
                            {
                                isLoading
                                ?
                                <span className='spinner-border spinner-border-sm'></span>
                                :
                                membersCount
                            }
                        </span> Intending Members
                    </p>
                    <p>
                        <span className='text-yrh fs-4 fw-bold'>
                            {
                                isLoading
                                ?
                                <span className='spinner-border spinner-border-sm'></span>
                                :
                                resultCount
                            }
                        </span> Results Uploaded
                    </p>
                </div>
                <div className="container pt-2">
                    <ul className="nav nav-tabs" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="tab" href="#quizlink">Send Quiz Link</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="tab" href="#intending">Intending Members</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="tab" href="#result">Assessment Result</a>
                        </li>                        
                    </ul>

                    <div className="tab-content">
                        <div id="quizlink" className="container tab-pane active"><br/>
                            <div>
                                <input className={errors.quiz && touched.quiz ? 'form-control is-invalid mb-2' : 'form-control mb-2'} name='quiz' onChange={handleChange} onBlur={handleBlur} placeholder='Quiz Link' type='' />
                                {errors.quiz && touched.quiz && <div className='text-danger'>{errors.quiz}</div>}
                                <Button onClick={handleSubmit} className='bg-yrh text-white'>
                                    Send Link
                                </Button>
                            </div>
                            <hr/>
                            <p>Quick Links</p>
                            <div className='d-flex justify-content-around'>
                                <Button onClick={()=>window.open(`${window.location.origin}/assessment`)} className='bg-yrh font-poppins text-white'>
                                    Short Recruitment Form
                                </Button>
                                <Button onClick={()=>window.open(`${window.location.origin}/result-upload`)} className='bg-yrh font-poppins text-white'>
                                    Upload Result
                                </Button>
                                <Button className='bg-yrh font-poppins text-white'>
                                    Send Congratulatory Mail
                                </Button>
                            </div>
                        </div>
                        <div id="intending" className="container tab-pane fade"><br/>
                        {
                            isLoading
                            ?
                            <p className='text-info'>Waiting for server...</p>
                            :
                            members.length !== 0 && error == ''
                            ?
                            <div className='row w-100 mx-auto my-4'>
                                <div className='table-responsive'>
                                    <table className='table table-primary'>
                                        <thead>
                                            <tr>
                                                <th>S/N</th>
                                                <th>Full Name</th>
                                                <th>Email</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            members.map((each, i)=>(
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td>{each.name}</td>
                                                    <td>{each.email}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>                                
                            </div>
                            :
                            members.length == 0 && error == ''
                            ?
                            <p className='fs-5 text-yrh'>No recent members...</p>
                            :
                            <p className='fs-5 text-danger'>{error}</p>
                        }
                        </div>
                        <div id="result" className="container tab-pane fade"><br/>
                        {
                            isLoading
                            ?
                            <p className='text-info'>Waiting for server...</p>
                            :
                            results.length !== 0 && error == ''
                            ?
                            <div className='row w-100 mx-auto my-4'>
                                <div className='table-responsive'>
                                    <table className='table table-primary'>
                                        <thead>
                                            <tr>
                                                <th>S/N</th>
                                                <th>Full Name</th>
                                                <th>Score</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            results.map((each, i)=>(
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td>{each.name}</td>
                                                    <td className='fs-4 fw-bold'>{each.score}%</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>                                
                            </div>
                            :
                            results.length == 0 && error == ''
                            ?
                            <p className='fs-5 text-yrh'>No recent members...</p>
                            :
                            <p className='fs-5 text-danger'>{error}</p>
                        }
                        </div>                        
                    </div>
                </div>                
            </div>
            {/* Snackbar */}
            <Snackbar open={snackbarstatus} onClose={handleClose} >
                <Alert severity={response.toLowerCase().includes('successfully') ? 'success' : 'error'} onClose={handleClose}>
                    {response}
                </Alert>
            </Snackbar>
            {/* Delete Dialog */}
            <Dialog open={delDialog} PaperProps={{
                style: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                }
            }}
            >
                <DialogContent>
                    <p>
                        <span className='spinner-border text-white'></span>
                    </p>
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}

export default Recruitment